import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getPostData,
    getPostDataCancelToken,
    resetPublicView } from '../../../actions/publicView/view';
import { decodeString, isYoutubeVideo } from '../../../utils/helper';
import CompanyBar from '../../loggedIn/Feed/common/CompanyBar';
import UserBar from '../../loggedIn/Feed/common/UserBar';
import YoutubeEmbed from '../../loggedIn/Feed/common/YoutubeEmbed';
import MetaBar from '../../loggedIn/Feed/common/MetaBar';
import DownloadIcon from '../../../assets/images/collaborations/view/download-2.svg';
import LocationIcon from '../../../assets/images/collaborations/view/pin-2.svg';
import Loader from '../../../components/misc/Loader';
import { typesOfCollaborations } from '../../../utils/collaborationHelper';
import { miscLinks } from '../../../utils/internalLinks';
import linkifyHtml from 'linkifyjs/html';
import UserName from '../../../components/profile/UserName';
import LoginSignUpContainer from '../../../components/login/LoginSignUpContainer';
import SeoHeadMeta from '../../../components/misc/SeoHeadMeta';
import ReadMoreLinkified from '../../loggedIn/Feed/common/ReadMoreLinkified';

function CollaborationView(props) {
    const [collaborationData, setCollaborationData] = useState(null),
        [showLoginForm, setShowLoginForm] = useState(false);
    useEffect(() => {
        props.getPostData('collaborate', props.match.params.id)
        .then(val => {
            if(!val) {
                props.history.replace(miscLinks.notFound);
            }
        })
        return function cleanup() {
            if (getPostDataCancelToken) getPostDataCancelToken();
            props.resetPublicView();
        }
    }, [props.match.params.id]);
    useEffect(() => {
        setCollaborationData(props.publicView.viewData);
    }, [props.publicView.viewData]);
    const collaboration = collaborationData && collaborationData.collaborate
        ? collaborationData.collaborate
        : null,
        youtubeId = collaboration
            && collaboration.video
            ? isYoutubeVideo(collaboration.video)
            : null,
        meta = collaborationData && collaborationData.meta
            ? collaborationData.meta
            : null;
    return (<div className="container">
         { collaborationData
            && collaborationData.seoTags
            && collaborationData.seoTags.title
            && <SeoHeadMeta title={collaborationData.seoTags.title}>
                <title>{decodeString(collaborationData.seoTags.title)}</title>
            </SeoHeadMeta>}
        <div className="collaboration__view collaboration__view--with-height">
            <div className="collaboration__view__details">
                {
                    props.publicView.fetching
                    ? (<Loader isCentered={true} withMargin={true} />)
                    : props.publicView.viewData
                    && props.publicView.viewData.collaborate
                    && collaborationData
                    ? (<>
                        <div className="collaboration__view__details__container">
                            <p className="collaboration__view__details__heading">Collaboration</p>
                            <ReadMoreLinkified className="collaboration__view__details__name"
                                hashtagEventLabel="Collaboration"
                                text={collaboration.title} />
                            <div className="collaboration__view__details__posted">
                                <div>
                                    {
                                        collaboration.company_id
                                        ? (<CompanyBar
                                            postType={typesOfCollaborations.normal}
                                            postId={collaboration && collaboration.id}
                                            cardData={collaboration}
                                            isPublic={true}
                                            publicClickAction={() => setShowLoginForm(true)}
                                            createdAt={collaboration.created_at}
                                            profileId={(collaboration.owner
                                                && collaboration.owner.profileId
                                                ? collaboration.owner.profileId
                                                : null)}
                                            company={collaboration.owner} />)
                                        : collaboration.profile
                                        ? (<UserBar
                                            isPublic={true}
                                            publicClickAction={() => setShowLoginForm(true)}
                                            postType={typesOfCollaborations.normal}
                                            postId={collaboration && collaboration.id}
                                            cardData={collaboration}
                                            createdAt={collaboration.created_at}
                                            profile={collaboration.profile} />)
                                        : (null)
                                    }
                                </div>
                                <div onClick={() => setShowLoginForm(true)} className="collaboration__view__details__action">
                                    <span className="collaboration__view__action__link--show-interest">SHOW INTEREST</span>
                                </div>
                            </div>
                            {
                                collaboration.images_meta
                                && !!collaboration.images_meta.length
                                &&  <div className="collaboration__view__details__images">
                                        {
                                            collaboration.images_meta.map((image, key) => {
                                                return <img src={image.original_photo}
                                                    key={key}
                                                    onClick={() => setShowLoginForm(true)}
                                                    className="collaboration__view__details__image cursor-pointer"
                                                    alt={`collaboration ${key + 1}`}/>
                                            })
                                        }
                                </div>
                            }
                            {
                                collaboration.video
                                && youtubeId
                                && <div className="collaboration__view__details__video-container"><YoutubeEmbed youtubeId={youtubeId} /></div>
                            }
                            {
                                collaboration.file1
                                &&  (<div onClick={() => setShowLoginForm(true)} className="collaboration__view__details__downloads">
                                    <p className="cursor-pointer collaboration__view__details__downloads__link">
                                        <img src={DownloadIcon} className="collaboration__view__details__downloads__icon" alt="download icon"/>
                                        <span className="collaboration__view__details__downloads__text">Download Document</span>
                                    </p>
                                </div>)
                            }
                            { collaboration.description
                                && <ReadMoreLinkified className="collaboration__view__details__description"
                                    isPublic={true}
                                    hashtagEventLabel="Collaboration"
                                    isOpen={true}
                                    text={collaboration.description} />
                            }
                            {
                                collaboration.financials
                                && <div className="collaboration__view__details__information__container">
                                    <div className="collaboration__view__details__information">
                                        <p className="collaboration__view__details__information__heading">Financial</p>
                                        <p className="collaboration__view__details__information__text collaboration__view__details__information__text--top-margin">
                                            { decodeString(collaboration.financials) }
                                        </p>
                                    </div>
                                </div>
                            }
                            { collaboration.location && <p className="collaboration__view__details__location">
                                <img src={LocationIcon} alt={collaboration.location} />
                                { collaboration.location }
                            </p> }
                            {
                                collaboration.company_id
                                && collaboration.profile
                                && <p className="collaboration__view__details__creator cursor-pointer" onClick={() => setShowLoginForm(true)}>Posted by <UserName isVerified={!!collaboration.profile.verified}
                                name={collaboration.profile.name} /></p>
                            }
                        </div>
                        {
                            meta
                            && collaboration
                            && <MetaBar
                                postType={typesOfCollaborations.normal}
                                postId={collaboration.id}
                                isPublic={true}
                                publicClickAction={() => setShowLoginForm(true)}
                                meta={meta} />
                        }
                    </>)
                    : null
                }
            </div>
        </div>
        {
            showLoginForm && <LoginSignUpContainer shouldOnlyToggle={true}
                publicPageLink={props.location.pathname}
                toggleLoginForm={() => setShowLoginForm(false)} />
        }
        {/* { showLoginForm && <LoginForm shouldOnlyToggle={true}
            toggleLoginForm={() => setShowLoginForm(false)} /> } */}
    </div>)
};

function mapStateToProps(state) {
    return {
        publicView: state.publicView
    }
}

const mapDispatchToProps = {
    getPostData,
    resetPublicView
}

export default connect(mapStateToProps, mapDispatchToProps)(CollaborationView);